export const imageCache: Record<string, HTMLImageElement> = {};

export const loadImage = (
  src: string,
  signal?: AbortSignal,
  retries: number = 3
): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    if (imageCache[src]) return resolve(imageCache[src]);

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = src;

    const abort = () => {
      img.src = '';
      reject(new Error('Image load aborted: ' + src));
    };

    if (signal) {
      if (signal.aborted) return abort();
      signal.addEventListener('abort', abort, { once: true });
    }

    img.onload = () => {
      if ('decode' in img) {
        img.decode()
          .then(() => {
            imageCache[src] = img;
            resolve(img);
          })
          .catch(() => {
            imageCache[src] = img;
            resolve(img);
          });
      } else {
        imageCache[src] = img;
        resolve(img);
      }
    };

    img.onerror = () => {
      if (retries > 0) {
        setTimeout(() => {
          loadImage(src, signal, retries - 1).then(resolve).catch(reject);
        }, 300);
      } else {
        reject(new Error('Failed to load ' + src));
      }
    };
  });
};
